import React from 'react';
import PackageIcon from 'mdi-react/PackageIcon';
import T from '@prisjakt/ui-translate';
import * as S from './styles';
import { ValidSuggestionTypes } from './types';

type Props = {
  onClick: () => void;
  text: string;
  selected: boolean;
  index: number;
  type: ValidSuggestionTypes;
  logo?: string;
};

export default ({ logo, type, onClick, text, selected, index }: Props) => {
  return (
    <S.Item
      onClick={onClick}
      selected={selected}
      style={{ order: index }}
      data-test="SearchSuggestionItem"
    >
      <S.RowInfo>
        <S.IconWrapper>
          {logo && type?.indexOf('category') !== -1 && (
            <S.Icon src={`https://cdn.pji.nu/g/cat/192/${logo}.png`} />
          )}
          {logo && type === 'product_collection' && <S.Icon src={logo} />}
          {type === 'offer_collection' && <PackageIcon />}
        </S.IconWrapper>
        {text}
      </S.RowInfo>
      <S.DirectLink data-test="DirectLink">
        <T domain="search">suggest.category</T>
      </S.DirectLink>
    </S.Item>
  );
};
